export default __webpack_public_path__ + "static/media/download-app-img.0f5720e1.webp";